<template>
    <div class="header">
        <div class="header-bck">
          <div class="lr">
            <div class="left">{{day}}</div>
            <div class="right">
                <div>{{week}}</div>
                <div>{{time}}</div>
            </div>
          </div>
            <img src="../../../../static/version2/标题箭头左.png" alt="" class="arrow-left">
            <img src="../../../../static/version2/左渐变（上）.png" alt="" class="gradual-left-top">
            <img src="../../../../static/version2/左渐变（下）.png" alt=""  class="gradual-right-top">
            <img src="../../../../static/version2/右渐变（上）.png" alt="" class="gradual-left-bottom">
            <img src="../../../../static/version2/右渐变（下）.png" alt="" class="gradual-right-bottom">
            <img src="../../../../static/version2/箭头上.png" alt="" class="arrow-top">
            <img src="../../../../static/version2/箭头下.png" alt="" class="arrow-bottom">
            <!-- <img v-if="!schoolName" class="title" src="../../../../static/img/1.png"/> -->
            <div class="title">
              <span class="text">{{schoolName}}</span>
            </div>
            <img src="../../../../static/version2/标题箭头右.png" alt="" class="arrow-right">
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import {getAbbreviation} from '@/api/databaseBin.js'
import BaseMixin from '@/views/_mixin'

export default {
  mixins: [BaseMixin],
  data() {
    return {
      day: '',
      time: '',
      week: '',
      schoolName: null
    }
  },
  async created() {
    setInterval(() => {
      this.week = moment().format('dddd')
      this.day = moment().format('LL')
      this.time = moment().format('LTS')
    }, 1000)
    const result = await getAbbreviation()
    if (result[this.dataMapping]) {
      this.schoolName = result[this.dataMapping] + '知识产权数字图谱'
      document.title = this.schoolName
    } else {
      this.schoolName = '知识产权数字图谱'
    }
  }
}
</script>
